import { CopyOne, Delete, Download, DownloadFour, MoreOne } from '@icon-park/react';
import style from './index.module.less'
import React, {forwardRef, useEffect, useImperativeHandle, useState, useReducer, useLayoutEffect, useRef} from "react";
import { Dropdown, MenuProps } from 'antd';
import { ipcSend } from '@/common/ipc';
import global from "@/global";
import {IconDelete, IconMakeCopy} from "@/Icon";
import {getImagePathWithTheme, imgPathPerfix} from "@/utils";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {
    EVENT_CARD_BLOCK_JUMP,
    EVENT_CLOSE_IMAGE_ACTION,
    EVENT_OPEN_IMAGE_ACTION,
    EVENT_REFRESH_EDIT_CARD, EVENT_UPDATE_CANVAS_NOTE_TO_DB, MAX_Z_INDEX
} from "@/Const";
import message from 'antd/lib/message';
import { t } from 'i18next';
import {removeCardImage} from "@model/card";

type TImgMsg = {
    x: number,
    y: number,
    id: string,
    fileName:string,
}
let el = null

let mElementId:any = null;

const ImgActionStyle = (props:{editor}) => {
    const [showEl, setShow] = useState<boolean>(false)
    const [imgMsg, setImgMsg] = useState<TImgMsg>({ x: 0, y: 0, id: '',fileName:'' })
    const [isShowMenu,setIsShowMenu] = useState(false);
    const mOnDeleteImage = useRef<any>(null);

    const items: MenuProps['items'] = [
        {
            label: t('Delete'),
            key: 'delete',
            icon: <IconDelete/>//<Delete theme="outline" size="24" fill="#333" />
        },
        {
            label: t('Copy'),
            key: 'copy',
            icon: <IconMakeCopy/>//<CopyOne theme="outline" size="24" fill="#333" />
        },
        // {
        //     label: '下载',
        //     key: 'download',
        //     icon: <DownloadFour theme="outline" size="24" fill="#333" />
        // },
    ];
    const handleMenuClick: MenuProps['onClick'] = async (e: any) => {

        switch (e.key) {
            case 'delete':
                const arrayImgs = el?.querySelectorAll('img');
                if (arrayImgs){
                    let doc = '';
                    if (props.editor){
                        doc = props.editor.getHTML();
                        // const arrayAllImgs = props.editor.$doc.querySelectorAll('img');
                        // console.log(arrayAllImgs);
                    }

                    arrayImgs.forEach(p=>{
                        if (p.src?.startsWith('atom://')){
                            var reg = new RegExp(p.src,'gi');
                            const matchs = doc.match(reg);
                            if (matchs && matchs.length <= 1){
                                removeCardImage(p.src.replace('atom://',''))
                            }
                        }
                    })
                }
                el?.remove?.()
                setShow(false);
                //刷新.....
                if (mElementId){
                    postMessage(EVENT_UPDATE_CANVAS_NOTE_TO_DB,{id:mElementId})
                }

                if (mOnDeleteImage.current){
                    mOnDeleteImage.current();
                }

                break;
            case 'copy':
                ipcSend('copy-img', imgMsg.fileName);
                message.info(t("Has copyed"))
                break;
            default:
                break;
        }
    };
    const menuProps = {
        items,
        onClick: handleMenuClick,
    };

    useEffect(()=>{
        recvMessage(EVENT_OPEN_IMAGE_ACTION,(msg,data)=>{
            el = data.data.el;
            mElementId = data.data.elementId;
            mOnDeleteImage.current = data.data.onDelete;
            // console.log(el.offsetWidth, el.offsetTop);
            // console.log('el: ', el);
            //高度要加上title的高度
            const txtTitle = document.getElementById('NOTE_TITLE_INPUT');
            let nTitleHeight = 0;
            if (txtTitle){
                nTitleHeight = txtTitle.offsetHeight;
            }
            let nOther = 0;
            if (location.href.includes('/card')){
                //如果是pagecard页面..要减
                nOther = 20;
            }
            setImgMsg({
                x: el.offsetWidth - 54,
                y: el.offsetTop +6 + nTitleHeight - (data.data.scrollTop || 0) - nOther,
                id: data.data.id,
                fileName:data.data.fileName,
            })
            setShow(true)
        });

        recvMessage(EVENT_CLOSE_IMAGE_ACTION,(msg,data)=>{
            setShow(false)
        })

        return ()=>{
            unSubscribe(EVENT_OPEN_IMAGE_ACTION);
            unSubscribe(EVENT_CLOSE_IMAGE_ACTION);
        }
    })

    useLayoutEffect(()=>{
        // @ts-ignore
        // window.openImgAction = (param: any) => {
        //     el = param.el
        //     // console.log(el.offsetWidth, el.offsetTop);
        //     // console.log('el: ', el);
        //     setImgMsg({
        //         x: el.offsetWidth - 54,
        //         y: el.offsetTop +6,
        //         id: param.id
        //     })
        //     setShow(true)
        // }
        // @ts-ignore
        window.closeImgAction = () => {
            setShow(false)
        }
        return () => {
            // delete window['openImgAction']
            delete window['closeImgAction']
        }
    })

    function download(){
        ipcSend('download-img',imgMsg.id)
    }
    if (!showEl) return null
    return (
        <>
            {
                !global.g_isPresentMode &&
                <div draggable={false} className={style.ImgActionStyleStyle} style={{left: imgMsg.x + 'px', top: imgMsg.y + 'px'}}
                     onMouseDown={()=>{
                    global.g_isImageActionMouseDown = true;
                }}
                     id='IMG_ACTION'>
                    {/*<Download theme="outline" size="24" className='cursor-pointer' fill="#333" onClick={download}/>*/}
                    <img className={'img-32 cursor-pointer'} style={{marginLeft:'-9px'}} src={getImagePathWithTheme('menu_download_black')} onClick={download}/>

                    <Dropdown menu={menuProps} overlayStyle={{zIndex:MAX_Z_INDEX}} trigger={['click']} >
                        {/*<MoreOne className={'cursor-pointer'} style={{marginLeft:'6px'}} theme="outline" size="24" fill="#333"/>*/}
                        <img className={'img-16 cursor-pointer'} style={{marginLeft:'6px'}} src={getImagePathWithTheme('vertical_more_gary')}/>
                    </Dropdown>
                </div>
            }
        </>

    )
}
export default ImgActionStyle;
















